export default __webpack_public_path__ + "static/media/dont-leave-term-insurance.5f13e830.png";